"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggle = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _Theme = require("../../Theme/Theme.variables");

var _Box = require("../Box/Box");

var _Icons = _interopRequireDefault(require("../Icons/Icons"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  transition: height 0.3s ease;\n\n  z-index: ", ";\n  ", ";\n\n  height: ", ";\n  position: ", ";\n\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: ", "px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  &.icon-closed {opacity: ", "}\n  &.icon-open {opacity: ", "}\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  height: 100%;\n  transition: all 0.15s ease;\n  position: relative;\n  :active {\n    background-color: ", ";\n  }\n\n  display: ", ";\n  @media (min-width: ", ") {\n    display: ", ";\n  }\n  @media (min-width: ", ") {\n    display: ", ";\n  }\n  @media (min-width: ", ") {\n    display: ", ";\n  }\n  @media (min-width: ", ") {\n    display: ", ";\n  }\n  @media (min-width: ", ") {\n    display: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ToggleContainer = (0, _styledComponents.default)(_Box.Box)(_templateObject(), function (props) {
  return props.contentAbsoluteXPosition && "\n    position: relative;\n  ";
});
var Trigger = (0, _styledComponents.default)(_Box.Box)(_templateObject2(), function (props) {
  return (0, _Theme.variables)(props).grayLighter;
}, function (props) {
  return props.isDisabled[0] ? 'none' : 'flex';
}, function (props) {
  return (0, _Theme.variables)(props).breakpoints['xs'];
}, function (props) {
  return props.isDisabled[1] ? 'none' : 'flex';
}, function (props) {
  return (0, _Theme.variables)(props).breakpoints['sm'];
}, function (props) {
  return props.isDisabled[2] ? 'none' : 'flex';
}, function (props) {
  return (0, _Theme.variables)(props).breakpoints['md'];
}, function (props) {
  return props.isDisabled[3] ? 'none' : 'flex';
}, function (props) {
  return (0, _Theme.variables)(props).breakpoints['lg'];
}, function (props) {
  return props.isDisabled[4] ? 'none' : 'flex';
}, function (props) {
  return (0, _Theme.variables)(props).breakpoints['xl'];
}, function (props) {
  return props.isDisabled[5] ? 'none' : 'flex';
});
var TiggerIcon = (0, _styledComponents.default)(_Box.Box)(_templateObject3(), function (props) {
  return _Theme.space[3];
}, function (props) {
  return props.isOpen[0] ? 0 : 1;
}, function (props) {
  return props.isOpen[0] ? 1 : 0;
}, function (props) {
  return _Theme.breakpointsArray.map(function (item, index) {
    return "\n        @media(min-width:".concat(item, ") {\n          &.icon-closed {opacity: ").concat(props.isOpen[index + 1] ? 0 : 1, "}\n          &.icon-open {opacity: ").concat(props.isOpen[index + 1] ? 1 : 0, "}\n        }\n      ");
  });
});
var Content = (0, _styledComponents.default)(_Box.Box)(_templateObject4(), function (props) {
  return props.contentAbsoluteXPosition ? '1000' : '0';
}, function (props) {
  return props.contentAbsoluteXPosition && "".concat(props.contentAbsoluteXPosition, ":0;");
}, function (props) {
  return props.isDisabled[0] ? 'auto' : props.isOpen[0] ? props.contentHeight : "0";
}, function (props) {
  return props.isDisabled[0] ? 'relative' : props.contentAbsoluteXPosition ? 'absolute' : 'relative';
}, function (props) {
  return _Theme.breakpointsArray.map(function (item, index) {
    return "\n        @media(min-width:".concat(item, ") {\n          height: ").concat(props.isDisabled[index + 1] ? 'auto' : props.isOpen[index + 1] ? props.contentHeight : '0', ";\n          position: ").concat(props.isDisabled[index + 1] ? 'relative' : props.contentAbsoluteXPosition ? 'absolute' : 'relative', ";\n          box-shadow: ").concat(!props.isDisabled[index + 1] && props.hasDropShadow ? function (props) {
      return (0, _Theme.variables)(props).shadows[3];
    } : 'none', ";\n        }\n      ");
  });
});

var Toggle =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Toggle, _PureComponent);

  function Toggle(props) {
    var _this;

    _classCallCheck(this, Toggle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toggle).call(this, props));
    _this.state = {
      isOpen: props.isInitialStateOpen,
      contentHeight: 'auto'
    };
    _this.timeout = null;
    _this.onResize = _this.onResize.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.childElementSelector = null;
    return _this;
  }

  _createClass(Toggle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.childElementSelector = _reactDom.default.findDOMNode(this).querySelector('.dropdown-content-inner');
      this.childElementSelector !== null && this.setHeight(this.childElementSelector);
      window.addEventListener('resize', this.onResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
      window.removeEventListener('resize', this.onResize);
      this.childElementSelector = null;
    }
  }, {
    key: "setHeight",
    value: function setHeight(childElementSelector) {
      childElementSelector !== undefined && childElementSelector !== null && this.setState(function () {
        return {
          contentHeight: childElementSelector.clientHeight + 'px'
        };
      });
    }
  }, {
    key: "onResize",
    value: function onResize() {
      var _this2 = this; // clear the timeout


      clearTimeout(this.timeout); // start timing for event "completion"

      this.timeout = setTimeout(function () {
        _this2.setHeight(_this2.childElementSelector);
      }, 300);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          contentHeight = _this$state.contentHeight;
      var _this$props = this.props,
          trigger = _this$props.trigger,
          isTriggerIconVisible = _this$props.isTriggerIconVisible,
          content = _this$props.content,
          contentAbsoluteXPosition = _this$props.contentAbsoluteXPosition,
          isDisabled = _this$props.isDisabled;
      return _react.default.createElement(ToggleContainer, this.props, trigger && _react.default.createElement(Trigger, {
        pr: isTriggerIconVisible && 4,
        isDisabled: isDisabled,
        style: {
          cursor: 'pointer'
        },
        onClick: function onClick() {
          return _this3.setState({
            isOpen: [!isOpen[0], !isOpen[1], !isOpen[2], !isOpen[3], !isOpen[4], !isOpen[5]]
          });
        }
      }, trigger, isTriggerIconVisible && _react.default.createElement(_Box.Box, null, _react.default.createElement(TiggerIcon, {
        isOpen: isOpen,
        className: "icon-closed"
      }, _react.default.createElement(_Icons.default.TriangleDown, {
        color: "black"
      })), _react.default.createElement(TiggerIcon, {
        isOpen: isOpen,
        className: "icon-open"
      }, _react.default.createElement(_Icons.default.TriangleUp, {
        color: "black"
      })))), _react.default.createElement(Content, {
        isOpen: isOpen,
        isDisabled: isDisabled,
        contentHeight: contentHeight,
        contentAbsoluteXPosition: contentAbsoluteXPosition
      }, _react.default.createElement(_Box.Box, {
        className: "dropdown-content-inner"
      }, content)));
    }
  }]);

  return Toggle;
}(_react.PureComponent);

exports.Toggle = Toggle;
Toggle.displayName = 'Toggle'; // Prop Types

Toggle.propTypes = {
  isInitialStateOpen: _propTypes.default.array,
  isDisabled: _propTypes.default.array,
  contentAbsoluteXPosition: _propTypes.default.string,
  trigger: _propTypes.default.object,
  isTriggerIconVisible: _propTypes.default.bool,
  content: _propTypes.default.object
};
Toggle.defaultProps = {
  isInitialStateOpen: [false, false, false, false, false, false],
  isTriggerIconVisible: true,
  contentAbsoluteXPosition: '',
  isDisabled: [false, false, false, false, false, false],
  hasDropShadow: false
};